import { FunctionComponent, useState } from 'react'
import { Link, Box, IconButton } from '@material-ui/core'
import { ReactComponent as SunIcon } from 'icons/sun.svg'
import { ReactComponent as MoonIcon } from 'icons/moon.svg'
import { Logo } from 'components/page/logo'
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useThemeSwitch } from 'hooks/theme'
import { BackendUser } from 'common/types'
import { useHistory } from 'react-router-dom'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { SideNavList } from '../side-nav/SideNavList'
import { Button } from 'common/atoms/Button/Button'

const StyledIconButton = styled(IconButton)`
  && {
    height: 20px;
    width: 20px;
  }
`

interface NavBarProps {
  backendUser: BackendUser
  getProfilePercentage: number
  inviteUsersByEmail: Function
  isFixed?: boolean
}

export const NavBar: FunctionComponent<NavBarProps> = ({
  backendUser,
  getProfilePercentage,
  inviteUsersByEmail,
  isFixed,
}) => {
  const [openSideBar, setOpenSideBar] = useState(false)
  const theme = useTheme()
  const history = useHistory()
  const { mode, switchTheme } = useThemeSwitch()
  const { isDevice } = useScreenSizes()
  const { setForwardingUrl,backendPartner } = useAuth()
  const { logEventAnalytics } = useAnalytics()

  const toggleDrawer = open => {
    setOpenSideBar(open)
  }

  return (
    <Box
      zIndex="1"
      p="0.5em"
      bgcolor={theme.colors.supplementary}
      color={theme.colors.accent1}
      top="0"
      position={isFixed ? 'fixed' : 'sticky'}
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height="4.335em"
      boxShadow={theme.colors.shadowXSmall}
    >
      <Box maxWidth="80em" display="flex" flexDirection="row" width="100%" alignItems="center">
        <Link
          onClick={() => {
            const partnerLog = {}
            const userLog = {}

            if (backendUser?.partnerId) {
              partnerLog['Partner ID'] = backendPartner?.id
              partnerLog['Company Name'] = backendPartner?.name
              partnerLog['Account Type'] = 'Partner'
            } else {
              userLog['Account Type'] = backendUser?.role
            }
            logEventAnalytics(
              backendUser?.partnerId ? 'Partner' : backendUser?.role,
              'Home page view',
              'mixpanel',
              'Home page view',
              {
                'User ID': backendUser?.id,
                ...partnerLog,
                ...userLog
              },
              backendUser?.id,
              {
                $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
                $email: backendUser?.username
              }
            )
          }}
        >
          <Logo size={isDevice ? 'x-small' : 'small'} bright={mode === 'dark'} />
        </Link>
        <Box
          display={isDevice ? 'none' : 'flex'}
          flexDirection="row"
          marginLeft="2em"
          width="100%"
          justifyContent="flex-end"
        >
          <Box alignSelf="center" m="1em">
            <Button
              design='primary'
              onClick={() => {
                setForwardingUrl(location?.pathname)
                history.push('/')
              }}
            >
              MEMBER LOGIN
            </Button>
          </Box>
          <Box alignSelf="center" m="1em">
            <StyledIconButton size="small" onClick={() => switchTheme()}>
              {mode === 'dark' ? <MoonIcon /> : <SunIcon />}
            </StyledIconButton>
          </Box>
        </Box>
        <SideNavList
          inviteUsersByEmail={inviteUsersByEmail}
          getProfilePercentage={getProfilePercentage}
          onPartnerLogin={() => {
            history.push('/')
            setForwardingUrl(location?.pathname)
          }}
          onMemberLogin={() => {
            history.push('/')
            setForwardingUrl(location?.pathname)
          }}
          
          toggleDrawer={toggleDrawer}
        />
      </Box>
    </Box>
  )
}
